module.exports = __webpack_public_path__ + "static/media/softcryliclogo.16789d7e.png";